import * as React from "react"
import { clx } from "../utils/clx"

type SkeletonProps = React.ComponentPropsWithoutRef<"div"> & {
  /** When true, the block is circular (e.g. avatar). */
  circle?: boolean
}
// bg-ui-bg-base-hover
const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, circle, ...props }, ref) => (
    <div
      ref={ref}
      role="presentation"
      aria-hidden
      className={clx(
        "bg-grey-20 animate-pulse rounded-md",
        circle && "rounded-full aspect-square",
        className,
      )}
      {...props}
    />
  ),
)
Skeleton.displayName = "Skeleton"

type SkeletonTextProps = React.ComponentPropsWithoutRef<"div"> & {
  lines?: number
}

const SkeletonText = React.forwardRef<HTMLDivElement, SkeletonTextProps>(
  ({ className, lines = 1, ...props }, ref) => (
    <div ref={ref} className={clx("flex flex-col gap-2", className)} {...props}>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton
          key={i}
          className={clx("h-3.5", i === lines - 1 && lines > 1 ? "w-4/5" : "w-full")}
        />
      ))}
    </div>
  ),
)
SkeletonText.displayName = "SkeletonText"

export { Skeleton, SkeletonText }
